import { render, staticRenderFns } from "./XMLAttributes.vue?vue&type=template&id=3ae55470&scoped=true&"
import script from "./XMLAttributes.vue?vue&type=script&lang=js&"
export * from "./XMLAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae55470",
  null
  
)

export default component.exports